import React from "react"
import MathText from "./MathText"
import { IMG_CLASS, imageSize } from "../lib/questionImages"

// Renderiza o conteúdo de uma questão: texto com LaTeX (via MathText) e
// marcadores de imagem [[IMG:nome.png]] vindos do motor de extração.
// As imagens são arquivos estáticos servidos de public/questoes/.

const IMG_RE = /\[\[IMG:([^\]]+)\]\]/g

interface QuestionContentProps {
  text: string
  className?: string
}

export default function QuestionContent({ text, className }: QuestionContentProps) {
  const raw = text || ""
  const parts: React.ReactNode[] = []
  let last = 0
  let m: RegExpExecArray | null
  IMG_RE.lastIndex = 0
  while ((m = IMG_RE.exec(raw)) !== null) {
    if (m.index > last) parts.push(<MathText key={parts.length} text={raw.slice(last, m.index)} />)
    // Zoom e fallback de erro vêm dos listeners de installQuestionImages —
    // a mesma figura chega também como HTML cru pelo RichContent.
    parts.push(
      <img
        key={parts.length}
        src={`/questoes/${encodeURIComponent(m[1].trim())}`}
        alt="Figura da questão"
        loading="lazy"
        {...imageSize(m[1])}
        className={IMG_CLASS}
      />
    )
    last = m.index + m[0].length
  }
  if (last < raw.length || parts.length === 0) parts.push(<MathText key={parts.length} text={raw.slice(last)} />)
  return <span className={className}>{parts}</span>
}
